<!-- Regions View -->
<div *ngIf="!selectedRegion" class="view-container">
    <div class="search-row">
        <div class="search-input-wrapper">
            <img height="16" width="16" src="assets/icons/search.svg" alt="Search icon" class="search-icon">
            <input
                type="text"
                placeholder="Search Region"
                [(ngModel)]="regionSearchText"
                (ngModelChange)="updateAreas()"
            />
        </div>
    </div>
    <div class="region-list">
        <div *ngFor="let region of filteredRegions" class="region-item">
            <div class="region-header" (click)="selectRegion(region)">
                <div class="region-info">
                    <span class="region-name">{{ region.name }}</span>
                    <span class="dot-separator">•</span>
                    <span class="district-count">{{ getDistrictCount(region) }} District</span>
                </div>
                <svg class="arrow-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
    </div>
</div>

<!-- Districts View -->
<div *ngIf="selectedRegion" class="view-container">
    <div class="search-row">
        <div class="search-input-wrapper with-back">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="back-arrow" (click)="selectedRegion = null">
                <path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <input
                type="text"
                placeholder="Search District"
                [(ngModel)]="areaSearchText"
                (ngModelChange)="updateAreas()"
            />
        </div>
    </div>
    <div class="area-list">
        <label class="area-item select-all-item">
            <input
                type="checkbox"
                [checked]="areAllAreasSelected()"
                (change)="toggleSelectAllAreas()"
            />
            <span class="checkmark"></span>
            <span class="area-name">All {{ selectedRegion.name }} Districts</span>
        </label>
        <label *ngFor="let area of areas" class="area-item">
            <input
                type="checkbox"
                [checked]="isAreaSelected({ id: area.id!, name: area.name })"
                (change)="onAreaSelect({ id: area.id!, name: area.name }, $event)"
            />
            <span class="checkmark"></span>
            <span class="area-name">{{ area.name }}</span>
        </label>
    </div>
</div>
